import { createContext, useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { Redirect, useParams } from 'react-router'
import { AppRoutes } from '../../app-routes'
import { DialogContextTypes } from '../../enums'
import {
  clearAxiosBoatHeader,
  clearAxiosClientHeader,
  setAxiosBoatHeader,
  setAxiosClientHeader,
} from '../../helpers/AuthorizationHelpers'
import { useDialogCtx } from '../../hooks/context-hooks'
import { getBoat } from '../../http'
import { Queries } from '../../queries'
import { IBoat } from '../../types/data-types'
import { CenteredSpinner } from '../Common/Spinner'

export const BoatLayoutContext = createContext<{ boat: IBoat; permission: number }>(undefined)

export const BoatLayoutContextProvider = ({ children }) => {
  const { id: boatId } = useParams<any>()
  const { data: boat, isLoading, isError, error } = useQuery([Queries.BOAT, boatId], () =>
    getBoat(Queries.BOAT, boatId),
  )
  const [providerValue, setProviderValue] = useState(null)
  const { getDialogs } = useDialogCtx()

  useEffect(() => {
    return () => {
      clearAxiosClientHeader()
      clearAxiosBoatHeader()
    }
  }, [])

  useEffect(() => {
    if (!!boat && boat != providerValue?.boat) {
      setProviderValue({ boat, permission: boat.permissionValue })
      setAxiosClientHeader(boat.clientId)
      setAxiosBoatHeader(boat.boatId)
    }
  }, [boat])
  if (isError) return <Redirect to={AppRoutes.NOT_FOUND} />

  return (
    <BoatLayoutContext.Provider value={providerValue}>
      {Object.values(getDialogs(DialogContextTypes.boat) ?? {})}
      {!providerValue ? <CenteredSpinner /> : children}
    </BoatLayoutContext.Provider>
  )
}
